// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"63":"8ea25d9de02b88de","544":"1af9bfeb75e7c1ae"}[chunkId] + ".js";
};